export { default } from './ImageGradientOverlay'
